var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-top"},[_c('div',{staticClass:"item-top-text"},[_vm._v(_vm._s(_vm.title))]),_c('CloseIcon',{staticClass:"item-top-close",attrs:{"color":"white"},on:{"click":function($event){return _vm.$emit('dashboardItemClose', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }